<script lang="ts">
    import {
        COMMON__logIn,
        COMMON__youMustBeLogged,
        FORM__logInToAddEntries,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import { getLoginUrl } from "@app/services/transferState-service";
    import InlineMessage from "./InlineMessage.svelte";
</script>

<InlineMessage messageType="warn">
    {getMessage(FORM__logInToAddEntries)}
    <a
        class="text-primary-700"
        href={getLoginUrl()}>{getMessage(COMMON__logIn)}</a>
</InlineMessage>
